module.exports = __webpack_public_path__ + "img/tu07.c8ac829a.jpg";